import { useState } from 'react';
import '../../../stylesheets/nav/nav.css';
import useAuthState from '../../../hooks/internal/auth/useAuthState.js';
import ProfileMenu from './ProfileMenu.js';

const ProfilePopover = ({ subscription, paymentMethod }) => {
    const { user } = useAuthState();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // TODO: move the style on teh inner container div to a css class
        // add to it the vertical and horizaontal centering (positionming of its children)
        // need to move up the hover from the avatar (and remove from avatar) to the conatiner since the whole container decides the mouse enter boolean toggle!
    // TODO: same for the pro plan text 
        // make this is class and add style properies in the style sheet where the class is
        // ** but not sure if we are going to include this sibling here or not - see what claude does - they actually do it - so lets do it
    // TODO: instead of the x on the modal that gets rendered to close the modal when we click on the subscription details list item
        // lets make it in that slick back arrow that claude uses - feels way more sophisticated - but still just acts as a modal close button!

    return (
            <div
                style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8}}
                onMouseEnter={() => setIsMenuOpen(true)}
                onMouseLeave={() => setIsMenuOpen(false)}
            >
                {/* Content Child 1 of Profile Popiver: Initial Avatar */}
                <div className="profile-menu-avatar">{user.name?.charAt(0).toUpperCase() || 'U'}</div>
                {/* Content Child 2 of Profile Popover: Tier Type */}
                { subscription && <span className="profile-menu-label"> {subscription.paymentStatus ? "Pro Tier" : "Basic Tier" } </span> }
                
                { isMenuOpen && (<ProfileMenu user={user} subscription={subscription} paymentMethod={paymentMethod} />) }
            </div>


    );
};

export default ProfilePopover;
